export default __webpack_public_path__ + "static/media/ViewVideos.82113572.svg";